import { WaterAdditionHistoryMessages, TranslationWaterAdditionHistoryMessages } from "../interfaces/waterAdditionHistoryMessages";

const waterAdditionHistoryMessages: TranslationWaterAdditionHistoryMessages = {
  [WaterAdditionHistoryMessages.title]: "Water Addition History",
  [WaterAdditionHistoryMessages.waterAdditionHistory]: "Water Addition History",
  [WaterAdditionHistoryMessages.filterTitle]: "Filter Water Addition History",
  [WaterAdditionHistoryMessages.fleetCode]: "Fleet",
  [WaterAdditionHistoryMessages.licensePlate]: "License Plate",
  [WaterAdditionHistoryMessages.startDate]: "Start Date",
  [WaterAdditionHistoryMessages.finishDate]: "Finish Date",
  [WaterAdditionHistoryMessages.driver]: "Driver",
  [WaterAdditionHistoryMessages.document]: "Doc.",
  [WaterAdditionHistoryMessages.vehicleState]: "Vehicle State",
  [WaterAdditionHistoryMessages.waterAdded]: "Water Added (L)",
  [WaterAdditionHistoryMessages.moment]: "Moment",
  [WaterAdditionHistoryMessages.address]: "Address",
  [WaterAdditionHistoryMessages.preDischarge]: "Pre-Discharge",
  [WaterAdditionHistoryMessages.postDischarge]: "Post-Discharge",
  [WaterAdditionHistoryMessages.noDataFound]: "No data found for the selected period"
};

export const messages = waterAdditionHistoryMessages;
